import React, { useState } from 'react';
import { Button, Radio, Form, InputNumber, Input } from 'antd';

const MyForm = ({ columns, onCancel, handleOk }) => {
    const [isJson, setDIsJson] = useState('Input');
    const { TextArea } = Input;
    const plainOptions = ['Input', 'JSON'];

    const onFinish = (values) => {
        if (isJson === 'Input') {
            handleOk(values);
        }
        else {
            handleOk(JSON.parse(values.jsonData));
        }

    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const onChange = ({ target: { value } }) => {
        setDIsJson(value);
    };

    const defaultObjStr = (type) => {
        if (isJson === 'Input') {
            let result
            if (type === 'number') result = 1
            else if (type === 'boolean') result = false
            else result = ''
            return result
        }
        else {
            let obj = {}
            for (let i = 0; i < columns.length; i++) {
                let key = columns[i].dataIndex
                if (columns[i].type === 'number') obj[key] = 1
                else if (columns[i].type === 'boolean') obj[key] = false
                else obj[key] = ''
            }
            return JSON.stringify(obj, null, 2);
        }

    }

    const BooleanRadio = (
        <Radio.Group>
            <Radio value={false}> false </Radio>
            <Radio value={true}> true </Radio>
        </Radio.Group>
    )

    return (

        <>
            <Radio.Group style={{ marginLeft: 0 }} options={plainOptions} onChange={onChange} value={isJson} />

            <Form
                name="basic"
                labelCol={{
                    span: 5,
                }}
                wrapperCol={{
                    span: 18,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >

                {isJson === 'Input' ?
                    columns.map((ele, ind) => {
                        const inputNode = ele.type === 'boolean' ? BooleanRadio : ele.type === 'number' ? <InputNumber /> : <Input />
                        return <div key={ele.dataIndex}>
                            <Form.Item initialValue={defaultObjStr(ele.type)} label={ele.dataIndex} name={ele.dataIndex} style={{ margin: 15 }} >
                                {inputNode}
                            </Form.Item>
                        </div>
                    })
                    :
                    <Form.Item initialValue={defaultObjStr()} label="jsonData" name='jsonData' style={{ margin: 15 }} >
                        <TextArea rows={columns.length + 4} />
                    </Form.Item>
                }

                <Form.Item
                    wrapperCol={{
                        offset: 16,
                        span: 7,
                    }}
                >
                    <div style={{ marginTop: '25px' }}>
                        {/* <p style={{ marginTop: '25px',  }}>123</p> */}
                        <Button onClick={onCancel}>
                            取消
                        </Button>
                        <Button style={{ float: 'right' }} type="primary" htmlType="submit">
                            确认
                        </Button>

                    </div>

                </Form.Item>
            </Form>
        </>

    )
};
export default MyForm;